(function () {
  'use strict';

  angular.module('ringbaPortal').component('liveCounter', {
    bindings: {
      cellValue: '<',
      customClass: '@',
      flickerClass: '@'
    },
    transclude: {
      'slot': '?customContent'
    },
    controller: LiveCounterController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/live-counter/live-counter.view.html'
  });

  function LiveCounterController(
    $timeout,
    $transclude
  ) {
    'ngInject';

    const vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    function onInit() {
      vm.customContent = $transclude.isSlotFilled('slot');
    }

    function onChanges(changes) {
      if (changes.cellValue && !changes.cellValue.isFirstChange() && changes.cellValue.previousValue !== changes.cellValue.currentValue) {
        _increaseDecreaseValue(changes.cellValue.currentValue, changes.cellValue.previousValue);
        $timeout(function () {
          vm.increaseValue = null;
        }, 3000);
      }
    }

    function _increaseDecreaseValue(current, previous) {
      if (current > previous) {
        vm.increaseValue = true;
      } else if (current < previous) {
        vm.increaseValue = false;
      }
    }

  }
})();
